<template>
  <div id="app" style="--accentColor: '#9C6DFE'">
    <router-view></router-view>
    <teleport-target id="portal-target-root" class="z-50" />
    <tutorial />
    <l-dialog-wrapper />
  </div>
</template>

<script setup lang="ts">
import { onBeforeMount, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { TeleportTarget } from 'vue-safe-teleport'

import { LDialogWrapper } from '@last/core-ui/paprika'

import Tutorial from '@/components/Tutorial.vue'
import { useLayoutStore } from '@/modules/layout/store/layout'

onBeforeMount(() => {
  useLayoutStore()
})

const { locale } = useI18n()
onMounted(() => {
  locale.value = window.navigator.language || locale.value || 'en'
})
</script>
